import { env } from './env';

const iosAppStoreUrl =
  env.IOS_APP_STORE_URL ||
  'https://apps.apple.com/us/search?term=TECNIQ';

const androidPlayStoreUrl =
  env.ANDROID_PLAY_STORE_URL ||
  'https://play.google.com/store/apps/details?id=com.tecniqmobile';

export const storeLinks = {
    ios: iosAppStoreUrl,
    android: androidPlayStoreUrl,
};
